import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import Tabs from 'components/admin/Helper/Tabs'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { getFormInitialValues, reduxForm, registerField } from 'redux-form'
import { confirmationModal, setDirtyFormState } from 'redux/navigation'
import { checkCategoryProperties, deleteProduct } from 'redux/product'
import { Icon, Segment } from 'semantic-ui-react'
import ProductAccessories from './Segments/ProductAccessories'
import ProductCriteriaProperties from './Segments/ProductCriteriaProperties'
import ProductFamilyMembers from './Segments/ProductFamilyMembers'
import ProductGeneric from './Segments/ProductGeneric'
import ProductLogs from './Segments/ProductLogs'
import ProductMedia from './Segments/ProductMedia'
import ProductProperties from './Segments/ProductProperties'
import ProductToDos from './Segments/ProductToDos'
import ProductSpecialItems from './Segments/ProductSpecialItems'

const i18nkey = 'admin.product.generic.'

const mapStateToProps = (state, ownProps) => {
  const {
    productLoading,
    formDisabled,
    importProduct,
    compareFormInitializing,
    detailFormInitializing,
    importFormInitializing,
  } = state.product
  const { productState } = state.importer
  const { keywords } = state.keywords
  const { users } = state.userAdmin
  const initialValues = getFormInitialValues(ownProps.form)(state)
  return {
    productState,
    productLoading,
    formDisabled,
    importProduct,
    keywords,
    users,
    initialValues,
    compareFormInitializing,
    detailFormInitializing,
    importFormInitializing,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      registerField,
      setDirtyFormState,
      checkCategoryProperties,
      confirmationModal,
      deleteProduct,
      push,
    },
    dispatch,
  )
}

class ProductEdit extends React.Component {
  componentDidUpdate(prevProps) {
    const { setDirtyFormState } = this.props
    if (prevProps.dirty !== this.props.dirty)
      setDirtyFormState(this.props.dirty)
  }

  getIcon(product) {
    if (product.kind === 'family') return config.icons.productFamily
    if (product.kind === 'product') return config.icons.product
    if (product.product_family_id) return config.icons.productFamilyMember
    return config.icons.product // fallback
  }

  getTabs(tabs) {
    // TODO: think up a nice way how to get formValues and reduxform props down to the children
    const { form, keywords, product, compareProduct } = this.props
    tabs = tabs || [
      'generic',
      'media',
      'properties',
      'accessories',
      'familymembers',
      'todos',
      'logs',
    ]
    if (product.kind === 'family' && !tabs.includes('familymembers'))
      tabs.push('familymembers')
    if (product.kind === 'family' && !tabs.includes('criteria'))
      tabs.push('criteria')

    const definedTabs = {
      generic: {
        title: I18n.t(i18nkey + 'generic'),
        key: 'generic',
        content: (
          <ProductGeneric {...{ product, form, compareProduct, keywords }} />
        ),
      },
      media: {
        title: I18n.t(i18nkey + 'media'),
        key: 'media',
        content: <ProductMedia {...{ form }} />,
      },
      properties: {
        title: I18n.t(i18nkey + 'properties'),
        key: 'properties',
        content: <ProductProperties {...{ product, compareProduct, form }} />,
      },
      criteria: {
        title: I18n.t(i18nkey + 'criteria'),
        key: 'criteria',
        content: (
          <ProductCriteriaProperties
            {...{
              familyMemberPropertyIds: product.family_member_property_ids,
              form,
            }}
          />
        ),
      },

      accessories: {
        title: I18n.t(i18nkey + 'accessories'),
        key: 'accessories',
        content: <ProductAccessories form={form}/>,
      },
      familymembers: {
        title: I18n.t(i18nkey + 'products'),
        key: 'familymembers',
        content: <ProductFamilyMembers form={form}/>,
      },
      todos: {
        title: I18n.t(i18nkey + 'todos'),
        key: 'todos',
        content: <ProductToDos form={form}/>,
      },
      logs: {
        title: I18n.t(i18nkey + 'logs'),
        key: 'logs',
        content: <ProductLogs logEntries={product.audits}/>,
      },
      specialitems: {
        title: I18n.t(i18nkey + 'specialitems'),
        key: 'specialitems',
        content: <ProductSpecialItems {...{ specialStockChanges: compareProduct && compareProduct.special_stock_changes }}/>,

      },
    }

    return tabs.map((tab) => definedTabs[tab])
  }

  actions() {
    // redux
    const {
      productState,
      product,
      initialValues,
      onSave,
      confirmationModal,
      deleteProduct,
      kind,
      setDirtyFormState,
      push, //connect
      handleSubmit,
      form,
      reset,
      pristine, //reduxForm
    } = this.props

    const {
      updated: updatedProducts = [],
      new: newProducts = [],
    } = productState

    let actions = []
    if (kind === 'compare' && product && product.article_number) {
      const productIndex = updatedProducts.findIndex(
        (p = {}) => p.article_number === product.article_number,
      )
      actions.push(
        {
          icon: 'step backward',
          secondary: true,
          disabled: productIndex === 0,
          onClick: () => {
            push(
              config.nodes.productCompare +
              updatedProducts[productIndex - 1].article_number,
            )
          },
        },
        {
          icon: 'step forward',
          secondary: true,
          disabled: productIndex === updatedProducts.length - 1,
          onClick: () => {
            push(
              config.nodes.productCompare +
              updatedProducts[productIndex + 1].article_number,
            )
          },
        },
        {
          icon: 'checkmark',
          color: 'green',
          content: I18n.t('admin.product.' + product.kind + '.action'),
          onClick: handleSubmit((formValues) => {
            onSave(formValues, initialValues, form)
          }),
        },
        {
          icon: 'cancel',
          secondary: true,
          content: I18n.t('global.cancel'),
          onClick: (event) => {
            confirmationModal({
              doNotDisplay: pristine,
              icon: config.icons.delete,
              negative: true,
              title: I18n.t('global.abortModal.title'),
              text: I18n.t('global.abortModal.text'),
              button: I18n.t('global.abortModal.button'),
              confirm: () => {
                event.preventDefault()
                push(config.nodes.dashboard)
                setDirtyFormState(false)
              },
            })
          },
        },
      )
    } else if (kind === 'import' && product && product.article_number) {
      const productIndex = newProducts.findIndex(
        (p = {}) => p.article_number === product.article_number,
      )
      actions.push(
        {
          icon: 'step backward',
          secondary: true,
          disabled: productIndex === 0,
          onClick: () => {
            push(
              config.nodes.productImport +
              newProducts[productIndex - 1].article_number,
            )
          },
        },
        {
          icon: 'step forward',
          secondary: true,
          disabled: productIndex === updatedProducts.length - 1,
          onClick: () => {
            push(
              config.nodes.productImport +
              newProducts[productIndex + 1].article_number,
            )
          },
        },
        {
          icon: 'checkmark',
          color: 'green',
          content: I18n.t('admin.product.' + product.kind + '.action'),
          onClick: handleSubmit((formValues) => {
            onSave(formValues, initialValues, form)
          }),
        },
        {
          icon: 'cancel',
          secondary: true,
          content: I18n.t('global.cancel'),
          onClick: (event) => {
            confirmationModal({
              doNotDisplay: pristine,
              icon: config.icons.delete,
              negative: true,
              title: I18n.t('global.abortModal.title'),
              text: I18n.t('global.abortModal.text'),
              button: I18n.t('global.abortModal.button'),
              confirm: () => {
                event.preventDefault()
                push(config.nodes.dashboard)
                setDirtyFormState(false)
              },
            })
          },
        },
      )
    } else {
      actions.push(
        {
          icon: 'cancel',
          disabled: pristine,
          secondary: true,
          content: I18n.t('global.cancel'),
          onClick: () => {
            confirmationModal({
              icon: config.icons.delete,
              negative: true,
              title: I18n.t('global.abortModal.title'),
              text: I18n.t('global.abortModal.text'),
              button: I18n.t('global.abortModal.button'),
              confirm: () => {
                reset()
              },
            })
          },
        },
        {
          icon: 'checkmark',
          color: 'green',
          disabled: pristine,
          content: I18n.t('admin.product.' + product.kind + '.action'),
          onClick: handleSubmit((formValues) => {
            onSave(formValues, initialValues, form)
          }),
        },
      )
    }

    if (product.kind === 'family')
      actions.push({
        icon: 'trash',
        color: 'red',
        disabled:
          product &&
          product.family_member_ids &&
          product.family_member_ids.length > 0,
        content: I18n.t('admin.product.deleteFamily.delete'),
        onClick: () => {
          confirmationModal({
            icon: config.icons.delete,
            negative: true,
            title: I18n.t('admin.product.deleteFamily.title'),
            text: I18n.t('admin.product.deleteFamily.text'),
            button: I18n.t('admin.product.deleteFamily.button'),
            confirm: () => {
              deleteProduct(product.id)
            },
          })
        },
      })

    return actions
  }

  render() {
    const dark = config.theme.dark

    // props
    const {
      initialized,
      product,
      dirty,
      compareFormInitializing,
      detailFormInitializing,
      importFormInitializing,
      tabs,
      startTab,
    } = this.props
    const loading =
      compareFormInitializing ||
      detailFormInitializing ||
      importFormInitializing
    const customActions = [
      <a
        className="ui blue icon right labeled button componentButton"
        target="_blank"
        href={`${config.storefront_url}/de/produkt/p/${product &&
        product.article_number}`}>
        <Icon name="external square"/>
        {I18n.t(i18nkey + 'product_page')}
      </a>,
    ]

    const headerProps = {
      actions: this.actions(),
      icon: this.getIcon(product),
      title:
        (product.wd_deleted
          ? I18n.t(i18nkey + 'deleted_product') + ' - '
          : '') +
        I18n.t('admin.product.' + product.kind + '.title', {
          articleNr: product && product.article_number,
        }),
      dirty,
      customActions: customActions,
    }

    const segmentProps = {
      loading,
      className: classNames(['payload', 'small', dark && 'inverted']),
    }
    return !initialized ? (
      <ComponentPlaceholder/>
    ) : (
      <div
        className={classNames([
          'productEdit',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader {...headerProps} />

        <Segment basic attached {...segmentProps}>
          <Tabs
            tabs={this.getTabs(tabs)}
            startTab={startTab}
            context="product_edit"
          />
        </Segment>
      </div>
    )
  }
}

ProductEdit = connect(mapStateToProps, mapDispatchToProps)(ProductEdit)
ProductEdit = reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(ProductEdit)
export default ProductEdit



// WEBPACK FOOTER //
// ./src/components/admin/Products/ProductEdit.jsx